<ng-container *ngIf="license$ | async as license">
  <div *ngIf="isToastVisible" class="toast-container">
    <div class="toast-content">
      <!-- Icono de advertencia -->
      <div class="toast-icon">
        <i class="pi pi-exclamation-triangle"></i>
      </div>

      <!-- Contenido del mensaje -->
      <div class="toast-message">
        <div class="toast-title">Licencia próxima a finalizar</div>
        <div class="toast-description">
          Comuníquese al
          <a
            href="https://api.whatsapp.com/send?phone=51978726211&text=Hola%2C%20necesito%20renovar%20mi%20licencia%20de%20GLtracker"
            target="_blank"
            class="inline-whatsapp-link"
            >978726211</a
          >
          para renovar.
          <span class="days-remaining"
            >Quedan {{ license.remainingTime | secondsToDays }} días</span
          >
        </div>
      </div>

      <!-- Botón de cerrar -->
      <div class="toast-close">
        <button (click)="closeToast()" class="close-btn" type="button">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>

    <!-- Botón de acción -->
    <div class="toast-actions">
      <button (click)="closeToast()" class="accept-btn" type="button">
        <i class="pi pi-check"></i>
        Entendido
      </button>
    </div>

    <!-- Barra de progreso/tiempo -->
    <div class="toast-progress">
      <div class="progress-bar"></div>
    </div>
  </div>
</ng-container>
